import { Injectable } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { IOverAskMessages } from '../../../../model/over-ask/over-ask';
import { OverAskMessagesProvider } from '../over-ask-messages.provider';

@Injectable()
export class OverAskDigitalMessagesProvider extends OverAskMessagesProvider {
    override messages: IOverAskMessages;

    constructor(siteCore: Sitecore) {
        super();

        this.messages = {
            acceptChanges: siteCore.betslip.overask.AcceptChanges,
            acceptChangesAndPlaceBet: siteCore.betslip.overask.AcceptChangesAndPlaceBet,
            cancel: siteCore.betslip.overask.Cancel,
            newOdds: siteCore.betslip.overask.NewOdds,
            stake: siteCore.betslip.overask.Stake,
            newStake: siteCore.betslip.overask.NewStake,
            pendingBetPlacementStatus: siteCore.betslip.overask.PendingBetPlacementStatus,
            pendingCheckingYourBet: siteCore.betslip.overask.PendingCheckingYourBet,
            reviewInfoMessage: siteCore.betslip.overask.ReviewInfoMessage,
            rejectDialogCancelButton: siteCore.betslip.overask.RejectDialogCancelButton,
            pendingRejectDialogContent: siteCore.betslip.overask.PendingRejectDialogContent,
            pendingRejectDialogDismissButton: siteCore.betslip.overask.PendingRejectDialogDismissButton,
            pendingTitle: siteCore.betslip.overask.PendingTitle,
            reviewRejectDialogTitle: siteCore.betslip.overask.ReviewRejectDialogTitle,
            reviewBadgeTitle: siteCore.betslip.overask.ReviewBadgeTitle,
            reviewLimitWarning: siteCore.betslip.overask.ReviewLimitWarning,
            reviewInPlayBadgeTitle: siteCore.betslip.overask.ReviewInPlayBadgeTitle,
            reviewInPlayInfoMessage: siteCore.betslip.overask.ReviewInPlayInfoMessage,
            reviewOfferExpires: siteCore.betslip.overask.ReviewOfferExpires,
            reviewRejectDialogContent: siteCore.betslip.overask.ReviewRejectDialogContent,
            reviewRejectDialogDismissButton: siteCore.betslip.overask.ReviewRejectDialogDismissButton,
            summaryOfferChanges: siteCore.betslip.overask.SummaryOfferChanges,
            removed: siteCore.betslip.overask.Removed,
            undo: siteCore.betslip.overask.Undo,
            totalOdds: siteCore.betslip.overask.TotalOdds,
            totalStake: siteCore.betslip.overask.TotalStake,
            possibleWinnings: siteCore.betslip.overask.PossibleWinnings,
            possibleWinningsNet: siteCore.betslip.overask.PossibleWinningsNet,
            tax: siteCore.betslip.overask.Tax,
            maxReturn: siteCore.betslip.overask.MaxReturn,
            ErrorOfferRejected: siteCore.betslip.overask.ErrorOfferRejected,
            ErrorOfferExpired: siteCore.betslip.overask.ErrorOfferExpired,
            ErrorOfferRejectedTitle: siteCore.betslip.overask.ErrorOfferRejectedTitle,
            ErrorOfferExpiredTitle: siteCore.betslip.overask.ErrorOfferExpiredTitle,
            ErrorFlowFailed: siteCore.betslip.overask.ErrorFlowFailed,
            ErrorFlowFailedTitle: siteCore.betslip.overask.ErrorFlowFailedTitle,
            ErrorOfferZeroStakeHint: siteCore.betslip.overask.ErrorOfferZeroStakeHint,
            ErrorMaximumWinOfBetExceeded: siteCore.betslip.overask.ErrorMaximumWinOfBetExceeded,
            betslipLockedToastMessage: siteCore.betslip.overask.BetslipLockedToastMessage,
            pendingRejectDialogTitle: siteCore.betslip.overask.PendingRejectDialogTitle,
            eachWayAbbr: siteCore.betslip.messages.EachWayAbbr,
            winMarketAbbr: siteCore.horseRacing.markets.WinShort,
            stakeChangeHeader: siteCore.betslip.overask.StakeChangeHeader,
            stakeChangeMsg: siteCore.betslip.overask.StakeChangeMsg,
            stakeChangeToggle: siteCore.betslip.overask.StakeChangeToggle,
            editStakeChangeDesktopUrl: siteCore.betslip.overask.EditStakeChangeDesktopUrl,
            editStakeChangeMobileUrl: siteCore.betslip.overask.EditStakeChangeMobileUrl,
        };
    }
}
